import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover"
import { observer } from "mobx-react-lite"

import { LcAddress } from "@/domains/core"
import { cn, shortestValue } from "@/domains/library"

export type ITokenInputBalance = {
  address: LcAddress
  decimals: number
  displayBalance: string
}

export const TokenInputBalance = observer(
  ({
    token,
    label,
    minDecimals = 3,
    className,
  }: {
    token: ITokenInputBalance | null | undefined
    label: React.ReactNode
    minDecimals?: number
    className?: string
  }) => {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <span className={cn("flex items-center gap-1 text-sm", className)}>
            {label}{" "}
            {token && token.displayBalance
              ? shortestValue({ value: String(token.displayBalance), decimals: token.decimals, minDecimals })
              : "0.00"}
          </span>
        </PopoverTrigger>
        <PopoverContent className="w-120">{token?.displayBalance}</PopoverContent>
      </Popover>
    )
  },
)
